var tr = Object.defineProperty;
var ae = Object.getOwnPropertySymbols;
var er = Object.prototype.hasOwnProperty, rr = Object.prototype.propertyIsEnumerable;
var se = (n, t, e) => t in n ? tr(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, qt = (n, t) => {
  for (var e in t || (t = {}))
    er.call(t, e) && se(n, e, t[e]);
  if (ae)
    for (var e of ae(t))
      rr.call(t, e) && se(n, e, t[e]);
  return n;
};
var It = (n, t, e) => new Promise((r, o) => {
  var i = (c) => {
    try {
      u(e.next(c));
    } catch (s) {
      o(s);
    }
  }, a = (c) => {
    try {
      u(e.throw(c));
    } catch (s) {
      o(s);
    }
  }, u = (c) => c.done ? r(c.value) : Promise.resolve(c.value).then(i, a);
  u((e = e.apply(n, t)).next());
});
import "./style.css";
import nr, { createContext as or, useContext as ir, useRef as ue, useState as ar, useEffect as ce } from "react";
import { useUnionText as sr, useHttpApi as ur, FormContainer as cr, ButtonGroup as lr, Button as dr, Captcha as fr, captchaValue as hr, UnionPortlet as pr } from "@o2-shared/react-components";
import { Alert as mr, Metro as yr, MetroItem as le, Input as gr, Icon as br } from "@o2-shared/react-components/wc";
import { Formik as wr, Form as vr, Field as xr } from "formik";
var Pe = { exports: {} }, Mt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kr = nr, Or = Symbol.for("react.element"), Tr = Symbol.for("react.fragment"), Pr = Object.prototype.hasOwnProperty, Dr = kr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, jr = { key: !0, ref: !0, __self: !0, __source: !0 };
function De(n, t, e) {
  var r, o = {}, i = null, a = null;
  e !== void 0 && (i = "" + e), t.key !== void 0 && (i = "" + t.key), t.ref !== void 0 && (a = t.ref);
  for (r in t)
    Pr.call(t, r) && !jr.hasOwnProperty(r) && (o[r] = t[r]);
  if (n && n.defaultProps)
    for (r in t = n.defaultProps, t)
      o[r] === void 0 && (o[r] = t[r]);
  return { $$typeof: Or, type: n, key: i, ref: a, props: o, _owner: Dr.current };
}
Mt.Fragment = Tr;
Mt.jsx = De;
Mt.jsxs = De;
Pe.exports = Mt;
var j = Pe.exports;
const je = or({
  portlet: "",
  config: {
    email: "",
    changeLoginUrl: "",
    validateEmailUrl: ""
  }
});
var Er = Object.defineProperty, Nr = Object.defineProperties, Sr = Object.getOwnPropertyDescriptors, de = Object.getOwnPropertySymbols, Mr = Object.prototype.hasOwnProperty, Lr = Object.prototype.propertyIsEnumerable, _t = (n, t, e) => t in n ? Er(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, Rr = (n, t) => {
  for (var e in t || (t = {}))
    Mr.call(t, e) && _t(n, e, t[e]);
  if (de)
    for (var e of de(t))
      Lr.call(t, e) && _t(n, e, t[e]);
  return n;
}, qr = (n, t) => Nr(n, Sr(t)), g = (n, t, e) => (_t(n, typeof t != "symbol" ? t + "" : t, e), e);
const fe = {
  required: "Toto pole je vyžadované.",
  birthNumber: "Nesprávny formát rodného čísla.",
  birthNumberLastDigits: "Nesprávny formát posledných 4 číslic z rodného čísla.",
  identificationNumber: "Nesprávny formát identifikačného čísla.",
  birthDate: "Zadajte menší dátum ako je dnešný dátum",
  dateFormat: (...n) => `Nesprávny formát dátumu. Zadajte dátum v tvare ${n[0]}.`,
  idCardNumber: "Nesprávny formát čísla dokladu.",
  idCardLastDigits: "Nesprávny formát posledných 4 číslic z občianského preukazu.",
  idCardValidity: "Zadajte dátum v budúcnosti",
  companyName: "Nesprávny formát názvu spoločnosti.",
  businessId: "Nesprávny formát IČO.",
  taxId: "Nesprávny formát DIČ.",
  vatId: "Nesprávny formát IČ DPH.",
  msisdnSk: "Zadaná hodnota musí byť slovenské telefónne číslo.",
  phoneNumber: "Nesprávny formát telefónneho čísla.",
  email: "Nesprávny formát emailu",
  simIcc: "Nesprávny formát posledného štvorčíslie novej SIM karty.",
  simCardNumber: "Nesprávny formát čísla SIM karty.",
  smartId: "Nesprávny formát bezpečnostného kódu.",
  smartIdRetype: "Bezpečnostné kódy sa nezhodujú",
  firstName: "Nesprávny formát mena.",
  lastName: "Nesprávny formát priezviska.",
  street: "Ulica môže obsahovať len písmená a/alebo číslice, prípadne bodku alebo čiarku. Maximálny počet znakov je 55.",
  streetInternational: "Ulica môže obsahovať len písmená a/alebo číslice, prípadne bodku alebo čiarku. Maximálny počet znakov je 55.",
  homeNumber: "Popisné číslo môže obsahovať len číslice a/alebo písmená, prípadne lomítko. Maximálny počet znakov je 20.",
  homeNumberInternational: "Popisné číslo môže obsahovať len číslice a/alebo písmená, prípadne lomítko. Maximálny počet znakov je 20.",
  city: "Nesprávny formát názvu mesta. Maximálny počet znakov je 40.",
  cityInternational: "Nesprávny formát názvu mesta. Maximálny počet znakov je 40.",
  zipCode: "Pole PSČ môže obsahovať len číslice. Maximálny počet znakov je 5.",
  zipCodeInternational: "Pole PSČ môže obsahovať písmena a číslice. Maximálny počet znakov je 11.",
  zipCodeForVerification: "Nesprávny formát PSČ. Zadajte ho v tvare 12345.",
  dateFrom: '"Dátum od" nemôže byť väčší ako "Dátum do".',
  dateTo: '"Dátum do" nemôže byť menší ako "Dátum od".',
  productNumber: "Nesprávny formát názvu produktu",
  decimal: "Nesprávny formát nezáporného desatinného čísla",
  promoExternalId: "Nesprávny formát Id ponuky",
  maxLength: (n) => `Maximálny počet znakov je ${n}.`,
  minLength: (n) => `Minimálny počet znakov je ${n}.`,
  promoUniversalCode: "Nesprávny formát univerzálneho kódu",
  numeric: "Nesprávny formát celého čísla",
  positiveNumeric: "Nesprávny formát celého nezáporného čísla",
  price: "Nesprávny formát ceny",
  positivePrice: "Nesprávny formát nezápornej ceny",
  residencePermit: "Nesprávny formát čísla povolenia na pobyt. Príklad: AB1234567",
  iccid: "Nesprávny formát ICCID",
  customerReferenceNumber: "Nesprávne číslo zákazníka.",
  requestOrderNumber: "Nesprávne číslo objednávky.",
  selectedCustomer: "Zákazník nebol vybratý.",
  selectedMsisdn: "Číslo nebolo vybraté.",
  idCardCheckbox: "Overenie identifikátorov musí byť zaškrtnuté.",
  alternative: {
    businessId: "Nesprávny formát IČO. Príklad: 35848863",
    idCardNumber: "Vyplňte číslo občianskeho preukazu. Príklad: SA123456",
    idCardLastDigits: "Vyplňte posledné 4 číslice z občianskeho preukazu. Príklad: 3456",
    phoneNumber: "Nesprávny formát telefónneho čísla. Príklad: 0949123456",
    birthNumber: "Nesprávny formát rodného čísla. Príklad: 999999/9999",
    birthNumberLastDigits: "Vyplňte posledné 4 číslice z rodného čísla. Príklad: 9999",
    required: "Povinný údaj."
  },
  passwordFormat: "Heslo nespĺňa podmienky",
  passwordRetype: "Zadané heslá sa nezhodujú",
  bscsCodeShort: "Nesprávny formát skráteného čísla predajne",
  bscsCode: "Nesprávny formát čísla predajne",
  sapCode: "Nesprávny formát SAP kódu",
  taxReceiptFolder: "Nesprávny formát zložky daňového dokladu",
  stockNumber: "Nesprávny formát čísla skladových zásob",
  adLogin: "Nesprávny formát prihlasovacieho mena",
  imei: "Nesprávny formát IMEI",
  contractNumber: "Nesprávny formát čísla kontraktu",
  hwContractNumber: "Nesprávny formát čísla fakturačného profilu",
  baInvoiceNumber: "Nesprávny formát čísla zmluvy na HW",
  existingSubcategory: "Podkategória sa už nachádza v zozname.",
  simSerial: "Nesprávny formát sériového čísla SIM karty",
  simPuk: "Nesprávny formát PUK kódu",
  latitude: "Nesprávny formát zemepisnej šírky",
  longitude: "Nesprávny formát zemepisnej dĺžky",
  minAge: (n) => `Osoba musí byť staršia než ${n} rokov`,
  iban: "Nesprávny formát IBAN.",
  tescoClubcard: "Zadaný formát čísla nie je správny. Prosím, uveďte platné číslo Clubcard.",
  url: "Zadaný formát URL adresy nie je správny. Prosím, zadajte platnú adresu (URL).",
  fsisdn: "Nesprávny formát. Zadajte telefónne číslo (príklad: 0949123456) alebo číslo služby (príklad: 11123456)."
}, Ee = 6048e5, Ir = 6e4, Hr = 36e5, Ar = 1e3, he = Symbol.for("constructDateFrom");
function F(n, t) {
  return typeof n == "function" ? n(t) : n && typeof n == "object" && he in n ? n[he](t) : n instanceof Date ? new n.constructor(t) : new Date(t);
}
function _(n, t) {
  return F(t || n, n);
}
function Ne(n, t, e) {
  const r = _(n, e == null ? void 0 : e.in);
  return isNaN(t) ? F((e == null ? void 0 : e.in) || n, NaN) : (t && r.setDate(r.getDate() + t), r);
}
let Cr = {};
function Lt() {
  return Cr;
}
function rt(n, t) {
  var e, r, o, i, a, u, c, s;
  const d = Lt(), p = (s = (c = (i = (o = t == null ? void 0 : t.weekStartsOn) != null ? o : (r = (e = t == null ? void 0 : t.locale) == null ? void 0 : e.options) == null ? void 0 : r.weekStartsOn) != null ? i : d.weekStartsOn) != null ? c : (u = (a = d.locale) == null ? void 0 : a.options) == null ? void 0 : u.weekStartsOn) != null ? s : 0, m = _(n, t == null ? void 0 : t.in), h = m.getDay(), v = (h < p ? 7 : 0) + h - p;
  return m.setDate(m.getDate() - v), m.setHours(0, 0, 0, 0), m;
}
function gt(n, t) {
  return rt(n, qr(Rr({}, t), { weekStartsOn: 1 }));
}
function Yr(n, t) {
  const e = _(n, t == null ? void 0 : t.in), r = e.getFullYear(), o = F(e, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = gt(o), a = F(e, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const u = gt(a);
  return e.getTime() >= i.getTime() ? r + 1 : e.getTime() >= u.getTime() ? r : r - 1;
}
function Se(n) {
  const t = _(n), e = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return e.setUTCFullYear(t.getFullYear()), +n - +e;
}
function $r(n, t) {
  const e = Yr(n, t), r = F((t == null ? void 0 : t.in) || n, 0);
  return r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0), gt(r);
}
function Fr(n, t) {
  const e = _(n, t == null ? void 0 : t.in), r = +gt(e) - +$r(e);
  return Math.round(r / Ee) + 1;
}
function Me(n, t) {
  var e, r, o, i, a, u, c, s;
  const d = _(n, t == null ? void 0 : t.in), p = d.getFullYear(), m = Lt(), h = (s = (c = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) != null ? o : (r = (e = t == null ? void 0 : t.locale) == null ? void 0 : e.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : m.firstWeekContainsDate) != null ? c : (u = (a = m.locale) == null ? void 0 : a.options) == null ? void 0 : u.firstWeekContainsDate) != null ? s : 1, v = F((t == null ? void 0 : t.in) || n, 0);
  v.setFullYear(p + 1, 0, h), v.setHours(0, 0, 0, 0);
  const k = rt(v, t), x = F((t == null ? void 0 : t.in) || n, 0);
  x.setFullYear(p, 0, h), x.setHours(0, 0, 0, 0);
  const l = rt(x, t);
  return +d >= +k ? p + 1 : +d >= +l ? p : p - 1;
}
function _r(n, t) {
  var e, r, o, i, a, u, c, s;
  const d = Lt(), p = (s = (c = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) != null ? o : (r = (e = t == null ? void 0 : t.locale) == null ? void 0 : e.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : d.firstWeekContainsDate) != null ? c : (u = (a = d.locale) == null ? void 0 : a.options) == null ? void 0 : u.firstWeekContainsDate) != null ? s : 1, m = Me(n, t), h = F((t == null ? void 0 : t.in) || n, 0);
  return h.setFullYear(m, 0, p), h.setHours(0, 0, 0, 0), rt(h, t);
}
function zr(n, t) {
  const e = _(n, t == null ? void 0 : t.in), r = +rt(e, t) - +_r(e, t);
  return Math.round(r / Ee) + 1;
}
function Br(n, t) {
  const e = _(n, t == null ? void 0 : t.in).getDay();
  return e === 0 ? 7 : e;
}
let Qr = class {
  constructor() {
    g(this, "subPriority", 0);
  }
  validate(t, e) {
    return !0;
  }
};
class Gr extends Qr {
  constructor(t, e, r, o, i) {
    super(), this.value = t, this.validateValue = e, this.setValue = r, this.priority = o, i && (this.subPriority = i);
  }
  validate(t, e) {
    return this.validateValue(t, this.value, e);
  }
  set(t, e, r) {
    return this.setValue(t, e, this.value, r);
  }
}
class O {
  run(t, e, r, o) {
    const i = this.parse(t, e, r, o);
    return i ? {
      setter: new Gr(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, e, r) {
    return !0;
  }
}
class Wr extends O {
  constructor() {
    super(...arguments), g(this, "priority", 140), g(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
      case "GGGGG":
        return r.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(t, { width: "wide" }) || r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
    }
  }
  set(t, e, r) {
    return e.era = r, t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const L = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, X = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function R(n, t) {
  return n && {
    value: t(n.value),
    rest: n.rest
  };
}
function E(n, t) {
  const e = t.match(n);
  return e ? {
    value: parseInt(e[0], 10),
    rest: t.slice(e[0].length)
  } : null;
}
function Z(n, t) {
  const e = t.match(n);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = e[1] === "+" ? 1 : -1, o = e[2] ? parseInt(e[2], 10) : 0, i = e[3] ? parseInt(e[3], 10) : 0, a = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: r * (o * Hr + i * Ir + a * Ar),
    rest: t.slice(e[0].length)
  };
}
function Le(n) {
  return E(L.anyDigitsSigned, n);
}
function S(n, t) {
  switch (n) {
    case 1:
      return E(L.singleDigit, t);
    case 2:
      return E(L.twoDigits, t);
    case 3:
      return E(L.threeDigits, t);
    case 4:
      return E(L.fourDigits, t);
    default:
      return E(new RegExp("^\\d{1," + n + "}"), t);
  }
}
function Re(n, t) {
  switch (n) {
    case 1:
      return E(L.singleDigitSigned, t);
    case 2:
      return E(L.twoDigitsSigned, t);
    case 3:
      return E(L.threeDigitsSigned, t);
    case 4:
      return E(L.fourDigitsSigned, t);
    default:
      return E(new RegExp("^-?\\d{1," + n + "}"), t);
  }
}
function Zt(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function qe(n, t) {
  const e = t > 0, r = e ? t : 1 - t;
  let o;
  if (r <= 50)
    o = n || 100;
  else {
    const i = r + 50, a = Math.trunc(i / 100) * 100, u = n >= i % 100;
    o = n + a - (u ? 100 : 0);
  }
  return e ? o : 1 - o;
}
function Ie(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
let Xr = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 130), g(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: e === "yy"
    });
    switch (e) {
      case "y":
        return R(S(4, t), o);
      case "yo":
        return R(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return R(S(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r) {
    const o = t.getFullYear();
    if (r.isTwoDigitYear) {
      const a = qe(
        r.year,
        o
      );
      return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const i = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
};
class Zr extends O {
  constructor() {
    super(...arguments), g(this, "priority", 130), g(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: e === "YY"
    });
    switch (e) {
      case "Y":
        return R(S(4, t), o);
      case "Yo":
        return R(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return R(S(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r, o) {
    const i = Me(t, o);
    if (r.isTwoDigitYear) {
      const u = qe(
        r.year,
        i
      );
      return t.setFullYear(
        u,
        0,
        o.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), rt(t, o);
    }
    const a = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(a, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), rt(t, o);
  }
}
class Ur extends O {
  constructor() {
    super(...arguments), g(this, "priority", 130), g(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e) {
    return Re(e === "R" ? 4 : e.length, t);
  }
  set(t, e, r) {
    const o = F(t, 0);
    return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), gt(o);
  }
}
class Vr extends O {
  constructor() {
    super(...arguments), g(this, "priority", 130), g(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e) {
    return Re(e === "u" ? 4 : e.length, t);
  }
  set(t, e, r) {
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
let Kr = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 120), g(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "Q":
      case "QQ":
        return S(e.length, t);
      case "Qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}, Jr = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 120), g(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "q":
      case "qq":
        return S(e.length, t);
      case "qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}, tn = class extends O {
  constructor() {
    super(...arguments), g(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]), g(this, "priority", 110);
  }
  parse(t, e, r) {
    const o = (i) => i - 1;
    switch (e) {
      case "M":
        return R(
          E(L.month, t),
          o
        );
      case "MM":
        return R(S(2, t), o);
      case "Mo":
        return R(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(t, { width: "wide", context: "formatting" }) || r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}, en = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 110), g(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (i) => i - 1;
    switch (e) {
      case "L":
        return R(
          E(L.month, t),
          o
        );
      case "LL":
        return R(S(2, t), o);
      case "Lo":
        return R(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(t, { width: "wide", context: "standalone" }) || r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
};
function rn(n, t, e) {
  const r = _(n, e == null ? void 0 : e.in), o = zr(r, e) - t;
  return r.setDate(r.getDate() - o * 7), _(r, e == null ? void 0 : e.in);
}
class nn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 100), g(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "w":
        return E(L.week, t);
      case "wo":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return S(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r, o) {
    return rt(rn(t, r, o), o);
  }
}
function on(n, t, e) {
  const r = _(n, e == null ? void 0 : e.in), o = Fr(r, e) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
let an = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 100), g(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "I":
        return E(L.week, t);
      case "Io":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return S(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r) {
    return gt(on(t, r));
  }
};
const sn = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], un = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
let cn = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 90), g(this, "subPriority", 1), g(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "d":
        return E(L.date, t);
      case "do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return S(e.length, t);
    }
  }
  validate(t, e) {
    const r = t.getFullYear(), o = Ie(r), i = t.getMonth();
    return o ? e >= 1 && e <= un[i] : e >= 1 && e <= sn[i];
  }
  set(t, e, r) {
    return t.setDate(r), t.setHours(0, 0, 0, 0), t;
  }
}, ln = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 90), g(this, "subpriority", 1), g(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "D":
      case "DD":
        return E(L.dayOfYear, t);
      case "Do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return S(e.length, t);
    }
  }
  validate(t, e) {
    const r = t.getFullYear();
    return Ie(r) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
  }
  set(t, e, r) {
    return t.setMonth(0, r), t.setHours(0, 0, 0, 0), t;
  }
};
function Ut(n, t, e) {
  var r, o, i, a, u, c, s, d;
  const p = Lt(), m = (d = (s = (a = (i = e == null ? void 0 : e.weekStartsOn) != null ? i : (o = (r = e == null ? void 0 : e.locale) == null ? void 0 : r.options) == null ? void 0 : o.weekStartsOn) != null ? a : p.weekStartsOn) != null ? s : (c = (u = p.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) != null ? d : 0, h = _(n, e == null ? void 0 : e.in), v = h.getDay(), k = (t % 7 + 7) % 7, x = 7 - m, l = t < 0 || t > 6 ? t - (v + x) % 7 : (k + x) % 7 - (v + x) % 7;
  return Ne(h, l, e);
}
let dn = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 90), g(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = Ut(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}, fn = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 90), g(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r, o) {
    const i = (a) => {
      const u = Math.floor((a - 1) / 7) * 7;
      return (a + o.weekStartsOn + 6) % 7 + u;
    };
    switch (e) {
      case "e":
      case "ee":
        return R(S(e.length, t), i);
      case "eo":
        return R(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = Ut(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}, hn = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 90), g(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, e, r, o) {
    const i = (a) => {
      const u = Math.floor((a - 1) / 7) * 7;
      return (a + o.weekStartsOn + 6) % 7 + u;
    };
    switch (e) {
      case "c":
      case "cc":
        return R(S(e.length, t), i);
      case "co":
        return R(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(t, { width: "wide", context: "standalone" }) || r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = Ut(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
};
function pn(n, t, e) {
  const r = _(n, e == null ? void 0 : e.in), o = Br(r, e), i = t - o;
  return Ne(r, i, e);
}
class mn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 90), g(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (i) => i === 0 ? 7 : i;
    switch (e) {
      case "i":
      case "ii":
        return S(e.length, t);
      case "io":
        return r.ordinalNumber(t, { unit: "day" });
      case "iii":
        return R(
          r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return R(
          r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return R(
          r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return R(
          r.day(t, {
            width: "wide",
            context: "formatting"
          }) || r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 7;
  }
  set(t, e, r) {
    return t = pn(t, r), t.setHours(0, 0, 0, 0), t;
  }
}
let yn = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 80), g(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(Zt(r), 0, 0, 0), t;
  }
}, gn = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 80), g(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(Zt(r), 0, 0, 0), t;
  }
};
class bn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 80), g(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(Zt(r), 0, 0, 0), t;
  }
}
class wn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 70), g(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "h":
        return E(L.hour12h, t);
      case "ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return S(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 12;
  }
  set(t, e, r) {
    const o = t.getHours() >= 12;
    return o && r < 12 ? t.setHours(r + 12, 0, 0, 0) : !o && r === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
let vn = class extends O {
  constructor() {
    super(...arguments), g(this, "priority", 70), g(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "H":
        return E(L.hour23h, t);
      case "Ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return S(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 23;
  }
  set(t, e, r) {
    return t.setHours(r, 0, 0, 0), t;
  }
};
class xn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 70), g(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "K":
        return E(L.hour11h, t);
      case "Ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return S(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.getHours() >= 12 && r < 12 ? t.setHours(r + 12, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class kn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 70), g(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "k":
        return E(L.hour24h, t);
      case "ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return S(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 24;
  }
  set(t, e, r) {
    const o = r <= 24 ? r % 24 : r;
    return t.setHours(o, 0, 0, 0), t;
  }
}
class On extends O {
  constructor() {
    super(...arguments), g(this, "priority", 60), g(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "m":
        return E(L.minute, t);
      case "mo":
        return r.ordinalNumber(t, { unit: "minute" });
      default:
        return S(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setMinutes(r, 0, 0), t;
  }
}
class Tn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 50), g(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "s":
        return E(L.second, t);
      case "so":
        return r.ordinalNumber(t, { unit: "second" });
      default:
        return S(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setSeconds(r, 0), t;
  }
}
class Pn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 30), g(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e) {
    const r = (o) => Math.trunc(o * Math.pow(10, -e.length + 3));
    return R(S(e.length, t), r);
  }
  set(t, e, r) {
    return t.setMilliseconds(r), t;
  }
}
class Dn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 10), g(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, e) {
    switch (e) {
      case "X":
        return Z(
          X.basicOptionalMinutes,
          t
        );
      case "XX":
        return Z(X.basic, t);
      case "XXXX":
        return Z(
          X.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Z(
          X.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Z(X.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : F(
      t,
      t.getTime() - Se(t) - r
    );
  }
}
class jn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 10), g(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, e) {
    switch (e) {
      case "x":
        return Z(
          X.basicOptionalMinutes,
          t
        );
      case "xx":
        return Z(X.basic, t);
      case "xxxx":
        return Z(
          X.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Z(
          X.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Z(X.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : F(
      t,
      t.getTime() - Se(t) - r
    );
  }
}
class En extends O {
  constructor() {
    super(...arguments), g(this, "priority", 40), g(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Le(t);
  }
  set(t, e, r) {
    return [F(t, r * 1e3), { timestampIsSet: !0 }];
  }
}
class Nn extends O {
  constructor() {
    super(...arguments), g(this, "priority", 20), g(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Le(t);
  }
  set(t, e, r) {
    return [F(t, r), { timestampIsSet: !0 }];
  }
}
new Wr(), new Xr(), new Zr(), new Ur(), new Vr(), new Kr(), new Jr(), new tn(), new en(), new nn(), new an(), new cn(), new ln(), new dn(), new fn(), new hn(), new mn(), new yn(), new gn(), new bn(), new wn(), new vn(), new xn(), new kn(), new On(), new Tn(), new Pn(), new Dn(), new jn(), new En(), new Nn();
function Sn(n, t) {
  if (!n)
    return t ? void 0 : fe.required;
  if (!n.match(/^[A-Za-z0-9]+(?:[_.-][A-Za-z0-9]+)*@[A-Za-z0-9]+(?:[.-][A-Za-z0-9]+)*\.[A-Za-z]{2,}$/g))
    return fe.email;
}
var Mn = Object.defineProperty, Ln = Object.defineProperties, Rn = Object.getOwnPropertyDescriptors, Dt = Object.getOwnPropertySymbols, He = Object.prototype.hasOwnProperty, Ae = Object.prototype.propertyIsEnumerable, zt = (n, t, e) => t in n ? Mn(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, A = (n, t) => {
  for (var e in t || (t = {}))
    He.call(t, e) && zt(n, e, t[e]);
  if (Dt)
    for (var e of Dt(t))
      Ae.call(t, e) && zt(n, e, t[e]);
  return n;
}, ct = (n, t) => Ln(n, Rn(t)), qn = (n, t) => {
  var e = {};
  for (var r in n)
    He.call(n, r) && t.indexOf(r) < 0 && (e[r] = n[r]);
  if (n != null && Dt)
    for (var r of Dt(n))
      t.indexOf(r) < 0 && Ae.call(n, r) && (e[r] = n[r]);
  return e;
}, y = (n, t, e) => (zt(n, typeof t != "symbol" ? t + "" : t, e), e), ot = (n, t, e) => new Promise((r, o) => {
  var i = (c) => {
    try {
      u(e.next(c));
    } catch (s) {
      o(s);
    }
  }, a = (c) => {
    try {
      u(e.throw(c));
    } catch (s) {
      o(s);
    }
  }, u = (c) => c.done ? r(c.value) : Promise.resolve(c.value).then(i, a);
  u((e = e.apply(n, t)).next());
});
const Ce = 6048e5, In = 6e4, Hn = 36e5, An = 1e3, pe = Symbol.for("constructDateFrom");
function z(n, t) {
  return typeof n == "function" ? n(t) : n && typeof n == "object" && pe in n ? n[pe](t) : n instanceof Date ? new n.constructor(t) : new Date(t);
}
function B(n, t) {
  return z(t || n, n);
}
function Ye(n, t, e) {
  const r = B(n, e == null ? void 0 : e.in);
  return isNaN(t) ? z((e == null ? void 0 : e.in) || n, NaN) : (t && r.setDate(r.getDate() + t), r);
}
let Cn = {};
function Rt() {
  return Cn;
}
function nt(n, t) {
  var e, r, o, i, a, u, c, s;
  const d = Rt(), p = (s = (c = (i = (o = t == null ? void 0 : t.weekStartsOn) != null ? o : (r = (e = t == null ? void 0 : t.locale) == null ? void 0 : e.options) == null ? void 0 : r.weekStartsOn) != null ? i : d.weekStartsOn) != null ? c : (u = (a = d.locale) == null ? void 0 : a.options) == null ? void 0 : u.weekStartsOn) != null ? s : 0, m = B(n, t == null ? void 0 : t.in), h = m.getDay(), v = (h < p ? 7 : 0) + h - p;
  return m.setDate(m.getDate() - v), m.setHours(0, 0, 0, 0), m;
}
function bt(n, t) {
  return nt(n, ct(A({}, t), { weekStartsOn: 1 }));
}
function Yn(n, t) {
  const e = B(n, t == null ? void 0 : t.in), r = e.getFullYear(), o = z(e, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = bt(o), a = z(e, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const u = bt(a);
  return e.getTime() >= i.getTime() ? r + 1 : e.getTime() >= u.getTime() ? r : r - 1;
}
function $e(n) {
  const t = B(n), e = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return e.setUTCFullYear(t.getFullYear()), +n - +e;
}
function $n(n, t) {
  const e = Yn(n, t), r = z((t == null ? void 0 : t.in) || n, 0);
  return r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0), bt(r);
}
function Fn(n, t) {
  const e = B(n, t == null ? void 0 : t.in), r = +bt(e) - +$n(e);
  return Math.round(r / Ce) + 1;
}
function Fe(n, t) {
  var e, r, o, i, a, u, c, s;
  const d = B(n, t == null ? void 0 : t.in), p = d.getFullYear(), m = Rt(), h = (s = (c = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) != null ? o : (r = (e = t == null ? void 0 : t.locale) == null ? void 0 : e.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : m.firstWeekContainsDate) != null ? c : (u = (a = m.locale) == null ? void 0 : a.options) == null ? void 0 : u.firstWeekContainsDate) != null ? s : 1, v = z((t == null ? void 0 : t.in) || n, 0);
  v.setFullYear(p + 1, 0, h), v.setHours(0, 0, 0, 0);
  const k = nt(v, t), x = z((t == null ? void 0 : t.in) || n, 0);
  x.setFullYear(p, 0, h), x.setHours(0, 0, 0, 0);
  const l = nt(x, t);
  return +d >= +k ? p + 1 : +d >= +l ? p : p - 1;
}
function _n(n, t) {
  var e, r, o, i, a, u, c, s;
  const d = Rt(), p = (s = (c = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) != null ? o : (r = (e = t == null ? void 0 : t.locale) == null ? void 0 : e.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : d.firstWeekContainsDate) != null ? c : (u = (a = d.locale) == null ? void 0 : a.options) == null ? void 0 : u.firstWeekContainsDate) != null ? s : 1, m = Fe(n, t), h = z((t == null ? void 0 : t.in) || n, 0);
  return h.setFullYear(m, 0, p), h.setHours(0, 0, 0, 0), nt(h, t);
}
function zn(n, t) {
  const e = B(n, t == null ? void 0 : t.in), r = +nt(e, t) - +_n(e, t);
  return Math.round(r / Ce) + 1;
}
function Bn(n, t) {
  const e = B(n, t == null ? void 0 : t.in).getDay();
  return e === 0 ? 7 : e;
}
class Qn {
  constructor() {
    y(this, "subPriority", 0);
  }
  validate(t, e) {
    return !0;
  }
}
class Gn extends Qn {
  constructor(t, e, r, o, i) {
    super(), this.value = t, this.validateValue = e, this.setValue = r, this.priority = o, i && (this.subPriority = i);
  }
  validate(t, e) {
    return this.validateValue(t, this.value, e);
  }
  set(t, e, r) {
    return this.setValue(t, e, this.value, r);
  }
}
class T {
  run(t, e, r, o) {
    const i = this.parse(t, e, r, o);
    return i ? {
      setter: new Gn(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, e, r) {
    return !0;
  }
}
class Wn extends T {
  constructor() {
    super(...arguments), y(this, "priority", 140), y(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
      case "GGGGG":
        return r.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(t, { width: "wide" }) || r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
    }
  }
  set(t, e, r) {
    return e.era = r, t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const q = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, U = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function I(n, t) {
  return n && {
    value: t(n.value),
    rest: n.rest
  };
}
function N(n, t) {
  const e = t.match(n);
  return e ? {
    value: parseInt(e[0], 10),
    rest: t.slice(e[0].length)
  } : null;
}
function V(n, t) {
  const e = t.match(n);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = e[1] === "+" ? 1 : -1, o = e[2] ? parseInt(e[2], 10) : 0, i = e[3] ? parseInt(e[3], 10) : 0, a = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: r * (o * Hn + i * In + a * An),
    rest: t.slice(e[0].length)
  };
}
function _e(n) {
  return N(q.anyDigitsSigned, n);
}
function M(n, t) {
  switch (n) {
    case 1:
      return N(q.singleDigit, t);
    case 2:
      return N(q.twoDigits, t);
    case 3:
      return N(q.threeDigits, t);
    case 4:
      return N(q.fourDigits, t);
    default:
      return N(new RegExp("^\\d{1," + n + "}"), t);
  }
}
function ze(n, t) {
  switch (n) {
    case 1:
      return N(q.singleDigitSigned, t);
    case 2:
      return N(q.twoDigitsSigned, t);
    case 3:
      return N(q.threeDigitsSigned, t);
    case 4:
      return N(q.fourDigitsSigned, t);
    default:
      return N(new RegExp("^-?\\d{1," + n + "}"), t);
  }
}
function Vt(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Be(n, t) {
  const e = t > 0, r = e ? t : 1 - t;
  let o;
  if (r <= 50)
    o = n || 100;
  else {
    const i = r + 50, a = Math.trunc(i / 100) * 100, u = n >= i % 100;
    o = n + a - (u ? 100 : 0);
  }
  return e ? o : 1 - o;
}
function Qe(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class Xn extends T {
  constructor() {
    super(...arguments), y(this, "priority", 130), y(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: e === "yy"
    });
    switch (e) {
      case "y":
        return I(M(4, t), o);
      case "yo":
        return I(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return I(M(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r) {
    const o = t.getFullYear();
    if (r.isTwoDigitYear) {
      const a = Be(
        r.year,
        o
      );
      return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const i = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Zn extends T {
  constructor() {
    super(...arguments), y(this, "priority", 130), y(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: e === "YY"
    });
    switch (e) {
      case "Y":
        return I(M(4, t), o);
      case "Yo":
        return I(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return I(M(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r, o) {
    const i = Fe(t, o);
    if (r.isTwoDigitYear) {
      const u = Be(
        r.year,
        i
      );
      return t.setFullYear(
        u,
        0,
        o.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), nt(t, o);
    }
    const a = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(a, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), nt(t, o);
  }
}
class Un extends T {
  constructor() {
    super(...arguments), y(this, "priority", 130), y(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e) {
    return ze(e === "R" ? 4 : e.length, t);
  }
  set(t, e, r) {
    const o = z(t, 0);
    return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), bt(o);
  }
}
class Vn extends T {
  constructor() {
    super(...arguments), y(this, "priority", 130), y(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e) {
    return ze(e === "u" ? 4 : e.length, t);
  }
  set(t, e, r) {
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Kn extends T {
  constructor() {
    super(...arguments), y(this, "priority", 120), y(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "Q":
      case "QQ":
        return M(e.length, t);
      case "Qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Jn extends T {
  constructor() {
    super(...arguments), y(this, "priority", 120), y(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "q":
      case "qq":
        return M(e.length, t);
      case "qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class to extends T {
  constructor() {
    super(...arguments), y(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]), y(this, "priority", 110);
  }
  parse(t, e, r) {
    const o = (i) => i - 1;
    switch (e) {
      case "M":
        return I(
          N(q.month, t),
          o
        );
      case "MM":
        return I(M(2, t), o);
      case "Mo":
        return I(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(t, { width: "wide", context: "formatting" }) || r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class eo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 110), y(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (i) => i - 1;
    switch (e) {
      case "L":
        return I(
          N(q.month, t),
          o
        );
      case "LL":
        return I(M(2, t), o);
      case "Lo":
        return I(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(t, { width: "wide", context: "standalone" }) || r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function ro(n, t, e) {
  const r = B(n, e == null ? void 0 : e.in), o = zn(r, e) - t;
  return r.setDate(r.getDate() - o * 7), B(r, e == null ? void 0 : e.in);
}
class no extends T {
  constructor() {
    super(...arguments), y(this, "priority", 100), y(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "w":
        return N(q.week, t);
      case "wo":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return M(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r, o) {
    return nt(ro(t, r, o), o);
  }
}
function oo(n, t, e) {
  const r = B(n, e == null ? void 0 : e.in), o = Fn(r, e) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
class io extends T {
  constructor() {
    super(...arguments), y(this, "priority", 100), y(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "I":
        return N(q.week, t);
      case "Io":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return M(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r) {
    return bt(oo(t, r));
  }
}
const ao = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], so = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class uo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 90), y(this, "subPriority", 1), y(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "d":
        return N(q.date, t);
      case "do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return M(e.length, t);
    }
  }
  validate(t, e) {
    const r = t.getFullYear(), o = Qe(r), i = t.getMonth();
    return o ? e >= 1 && e <= so[i] : e >= 1 && e <= ao[i];
  }
  set(t, e, r) {
    return t.setDate(r), t.setHours(0, 0, 0, 0), t;
  }
}
class co extends T {
  constructor() {
    super(...arguments), y(this, "priority", 90), y(this, "subpriority", 1), y(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "D":
      case "DD":
        return N(q.dayOfYear, t);
      case "Do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return M(e.length, t);
    }
  }
  validate(t, e) {
    const r = t.getFullYear();
    return Qe(r) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
  }
  set(t, e, r) {
    return t.setMonth(0, r), t.setHours(0, 0, 0, 0), t;
  }
}
function Kt(n, t, e) {
  var r, o, i, a, u, c, s, d;
  const p = Rt(), m = (d = (s = (a = (i = e == null ? void 0 : e.weekStartsOn) != null ? i : (o = (r = e == null ? void 0 : e.locale) == null ? void 0 : r.options) == null ? void 0 : o.weekStartsOn) != null ? a : p.weekStartsOn) != null ? s : (c = (u = p.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) != null ? d : 0, h = B(n, e == null ? void 0 : e.in), v = h.getDay(), k = (t % 7 + 7) % 7, x = 7 - m, l = t < 0 || t > 6 ? t - (v + x) % 7 : (k + x) % 7 - (v + x) % 7;
  return Ye(h, l, e);
}
class lo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 90), y(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = Kt(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
class fo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 90), y(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r, o) {
    const i = (a) => {
      const u = Math.floor((a - 1) / 7) * 7;
      return (a + o.weekStartsOn + 6) % 7 + u;
    };
    switch (e) {
      case "e":
      case "ee":
        return I(M(e.length, t), i);
      case "eo":
        return I(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = Kt(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
class ho extends T {
  constructor() {
    super(...arguments), y(this, "priority", 90), y(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, e, r, o) {
    const i = (a) => {
      const u = Math.floor((a - 1) / 7) * 7;
      return (a + o.weekStartsOn + 6) % 7 + u;
    };
    switch (e) {
      case "c":
      case "cc":
        return I(M(e.length, t), i);
      case "co":
        return I(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(t, { width: "wide", context: "standalone" }) || r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = Kt(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
function po(n, t, e) {
  const r = B(n, e == null ? void 0 : e.in), o = Bn(r, e), i = t - o;
  return Ye(r, i, e);
}
class mo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 90), y(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (i) => i === 0 ? 7 : i;
    switch (e) {
      case "i":
      case "ii":
        return M(e.length, t);
      case "io":
        return r.ordinalNumber(t, { unit: "day" });
      case "iii":
        return I(
          r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return I(
          r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return I(
          r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return I(
          r.day(t, {
            width: "wide",
            context: "formatting"
          }) || r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 7;
  }
  set(t, e, r) {
    return t = po(t, r), t.setHours(0, 0, 0, 0), t;
  }
}
class yo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 80), y(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(Vt(r), 0, 0, 0), t;
  }
}
class go extends T {
  constructor() {
    super(...arguments), y(this, "priority", 80), y(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(Vt(r), 0, 0, 0), t;
  }
}
class bo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 80), y(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(Vt(r), 0, 0, 0), t;
  }
}
class wo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 70), y(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "h":
        return N(q.hour12h, t);
      case "ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return M(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 12;
  }
  set(t, e, r) {
    const o = t.getHours() >= 12;
    return o && r < 12 ? t.setHours(r + 12, 0, 0, 0) : !o && r === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class vo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 70), y(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "H":
        return N(q.hour23h, t);
      case "Ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return M(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 23;
  }
  set(t, e, r) {
    return t.setHours(r, 0, 0, 0), t;
  }
}
class xo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 70), y(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "K":
        return N(q.hour11h, t);
      case "Ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return M(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.getHours() >= 12 && r < 12 ? t.setHours(r + 12, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class ko extends T {
  constructor() {
    super(...arguments), y(this, "priority", 70), y(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "k":
        return N(q.hour24h, t);
      case "ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return M(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 24;
  }
  set(t, e, r) {
    const o = r <= 24 ? r % 24 : r;
    return t.setHours(o, 0, 0, 0), t;
  }
}
class Oo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 60), y(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "m":
        return N(q.minute, t);
      case "mo":
        return r.ordinalNumber(t, { unit: "minute" });
      default:
        return M(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setMinutes(r, 0, 0), t;
  }
}
class To extends T {
  constructor() {
    super(...arguments), y(this, "priority", 50), y(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "s":
        return N(q.second, t);
      case "so":
        return r.ordinalNumber(t, { unit: "second" });
      default:
        return M(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setSeconds(r, 0), t;
  }
}
class Po extends T {
  constructor() {
    super(...arguments), y(this, "priority", 30), y(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e) {
    const r = (o) => Math.trunc(o * Math.pow(10, -e.length + 3));
    return I(M(e.length, t), r);
  }
  set(t, e, r) {
    return t.setMilliseconds(r), t;
  }
}
class Do extends T {
  constructor() {
    super(...arguments), y(this, "priority", 10), y(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, e) {
    switch (e) {
      case "X":
        return V(
          U.basicOptionalMinutes,
          t
        );
      case "XX":
        return V(U.basic, t);
      case "XXXX":
        return V(
          U.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return V(
          U.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return V(U.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : z(
      t,
      t.getTime() - $e(t) - r
    );
  }
}
class jo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 10), y(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, e) {
    switch (e) {
      case "x":
        return V(
          U.basicOptionalMinutes,
          t
        );
      case "xx":
        return V(U.basic, t);
      case "xxxx":
        return V(
          U.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return V(
          U.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return V(U.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : z(
      t,
      t.getTime() - $e(t) - r
    );
  }
}
class Eo extends T {
  constructor() {
    super(...arguments), y(this, "priority", 40), y(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return _e(t);
  }
  set(t, e, r) {
    return [z(t, r * 1e3), { timestampIsSet: !0 }];
  }
}
class No extends T {
  constructor() {
    super(...arguments), y(this, "priority", 20), y(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return _e(t);
  }
  set(t, e, r) {
    return [z(t, r), { timestampIsSet: !0 }];
  }
}
new Wn(), new Xn(), new Zn(), new Un(), new Vn(), new Kn(), new Jn(), new to(), new eo(), new no(), new io(), new uo(), new co(), new lo(), new fo(), new ho(), new mo(), new yo(), new go(), new bo(), new wo(), new vo(), new xo(), new ko(), new Oo(), new To(), new Po(), new Do(), new jo(), new Eo(), new No();
function Bt() {
  return process.env.LOGGER_ENV !== "PROD";
}
function So() {
  return process.env.LOGGER_ENV !== "PROD" && process.env.LOGGER_ENV !== "PPT";
}
class G {
  static get currentDate() {
    const t = (s) => s < 10 ? `0${s}` : `${s}`, e = new Date(Date.now()), r = t(e.getFullYear()), o = t(e.getMonth()), i = t(e.getDate()), a = t(e.getHours()), u = t(e.getMinutes()), c = t(e.getSeconds());
    return `${r}-${o}-${i} ${a}:${u}:${c}`;
  }
  /**
   * Log a message at the level specified in first argument.
   *
   * @param level the log level
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static log(t, e, r, ...o) {
    if (Bt() && !(t === "DEBUG" && !So()))
      switch (t) {
        case "DEBUG":
          console.debug(`${G.currentDate} - ${e}: ${r}`, ...o);
          break;
        case "INFO":
          console.info(`${G.currentDate} - ${e}: ${r}`, ...o);
          break;
        case "WARN":
          console.warn(`${G.currentDate} - ${e}: ${r}`, ...o);
          break;
        case "ERROR":
          console.error(`${G.currentDate} - ${e}: ${r}`, ...o);
          break;
      }
  }
  /**
   * Log a message at the DEBUG level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static debug(t, e, ...r) {
    G.log("DEBUG", t, e, ...r);
  }
  /**
   * Log a message at the INFO level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static info(t, e, ...r) {
    G.log("INFO", t, e, ...r);
  }
  /**
   * Log a message at the WARN level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static warn(t, e, ...r) {
    G.log("WARN", t, e, ...r);
  }
  /**
   * Log a message at the ERROR level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static error(t, e, ...r) {
    G.log("ERROR", t, e, ...r);
  }
}
function vt(n, t) {
  var e, r;
  (r = (e = window.dtrum) == null ? void 0 : e.reportCustomError) == null || r.call(e, "REACT", n, t);
}
var Mo = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
(function(n) {
  n();
})(function() {
  function n(l, f) {
    if (!(l instanceof f))
      throw new TypeError("Cannot call a class as a function");
  }
  function t(l, f) {
    for (var b = 0; b < f.length; b++) {
      var w = f[b];
      w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(l, w.key, w);
    }
  }
  function e(l, f, b) {
    return f && t(l.prototype, f), b && t(l, b), Object.defineProperty(l, "prototype", {
      writable: !1
    }), l;
  }
  function r(l, f) {
    if (typeof f != "function" && f !== null)
      throw new TypeError("Super expression must either be null or a function");
    l.prototype = Object.create(f && f.prototype, {
      constructor: {
        value: l,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(l, "prototype", {
      writable: !1
    }), f && i(l, f);
  }
  function o(l) {
    return o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(f) {
      return f.__proto__ || Object.getPrototypeOf(f);
    }, o(l);
  }
  function i(l, f) {
    return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(b, w) {
      return b.__proto__ = w, b;
    }, i(l, f);
  }
  function a() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (l) {
      return !1;
    }
  }
  function u(l) {
    if (l === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return l;
  }
  function c(l, f) {
    if (f && (typeof f == "object" || typeof f == "function"))
      return f;
    if (f !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return u(l);
  }
  function s(l) {
    var f = a();
    return function() {
      var b = o(l), w;
      if (f) {
        var P = o(this).constructor;
        w = Reflect.construct(b, arguments, P);
      } else
        w = b.apply(this, arguments);
      return c(this, w);
    };
  }
  function d(l, f) {
    for (; !Object.prototype.hasOwnProperty.call(l, f) && (l = o(l), l !== null); )
      ;
    return l;
  }
  function p() {
    return typeof Reflect != "undefined" && Reflect.get ? p = Reflect.get.bind() : p = function(l, f, b) {
      var w = d(l, f);
      if (w) {
        var P = Object.getOwnPropertyDescriptor(w, f);
        return P.get ? P.get.call(arguments.length < 3 ? l : b) : P.value;
      }
    }, p.apply(this, arguments);
  }
  var m = /* @__PURE__ */ function() {
    function l() {
      n(this, l), Object.defineProperty(this, "listeners", {
        value: {},
        writable: !0,
        configurable: !0
      });
    }
    return e(l, [{
      key: "addEventListener",
      value: function(f, b, w) {
        f in this.listeners || (this.listeners[f] = []), this.listeners[f].push({
          callback: b,
          options: w
        });
      }
    }, {
      key: "removeEventListener",
      value: function(f, b) {
        if (f in this.listeners) {
          for (var w = this.listeners[f], P = 0, J = w.length; P < J; P++)
            if (w[P].callback === b) {
              w.splice(P, 1);
              return;
            }
        }
      }
    }, {
      key: "dispatchEvent",
      value: function(f) {
        if (f.type in this.listeners) {
          for (var b = this.listeners[f.type], w = b.slice(), P = 0, J = w.length; P < J; P++) {
            var Y = w[P];
            try {
              Y.callback.call(this, f);
            } catch (it) {
              Promise.resolve().then(function() {
                throw it;
              });
            }
            Y.options && Y.options.once && this.removeEventListener(f.type, Y.callback);
          }
          return !f.defaultPrevented;
        }
      }
    }]), l;
  }(), h = /* @__PURE__ */ function(l) {
    r(b, l);
    var f = s(b);
    function b() {
      var w;
      return n(this, b), w = f.call(this), w.listeners || m.call(u(w)), Object.defineProperty(u(w), "aborted", {
        value: !1,
        writable: !0,
        configurable: !0
      }), Object.defineProperty(u(w), "onabort", {
        value: null,
        writable: !0,
        configurable: !0
      }), Object.defineProperty(u(w), "reason", {
        value: void 0,
        writable: !0,
        configurable: !0
      }), w;
    }
    return e(b, [{
      key: "toString",
      value: function() {
        return "[object AbortSignal]";
      }
    }, {
      key: "dispatchEvent",
      value: function(w) {
        w.type === "abort" && (this.aborted = !0, typeof this.onabort == "function" && this.onabort.call(this, w)), p(o(b.prototype), "dispatchEvent", this).call(this, w);
      }
    }]), b;
  }(m), v = /* @__PURE__ */ function() {
    function l() {
      n(this, l), Object.defineProperty(this, "signal", {
        value: new h(),
        writable: !0,
        configurable: !0
      });
    }
    return e(l, [{
      key: "abort",
      value: function(f) {
        var b;
        try {
          b = new Event("abort");
        } catch (P) {
          typeof document != "undefined" ? document.createEvent ? (b = document.createEvent("Event"), b.initEvent("abort", !1, !1)) : (b = document.createEventObject(), b.type = "abort") : b = {
            type: "abort",
            bubbles: !1,
            cancelable: !1
          };
        }
        var w = f;
        if (w === void 0)
          if (typeof document == "undefined")
            w = new Error("This operation was aborted"), w.name = "AbortError";
          else
            try {
              w = new DOMException("signal is aborted without reason");
            } catch (P) {
              w = new Error("This operation was aborted"), w.name = "AbortError";
            }
        this.signal.reason = w, this.signal.dispatchEvent(b);
      }
    }, {
      key: "toString",
      value: function() {
        return "[object AbortController]";
      }
    }]), l;
  }();
  typeof Symbol != "undefined" && Symbol.toStringTag && (v.prototype[Symbol.toStringTag] = "AbortController", h.prototype[Symbol.toStringTag] = "AbortSignal");
  function k(l) {
    return l.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL ? (console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill"), !0) : typeof l.Request == "function" && !l.Request.prototype.hasOwnProperty("signal") || !l.AbortController;
  }
  function x(l) {
    typeof l == "function" && (l = {
      fetch: l
    });
    var f = l, b = f.fetch, w = f.Request, P = w === void 0 ? b.Request : w, J = f.AbortController, Y = f.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL, it = Y === void 0 ? !1 : Y;
    if (!k({
      fetch: b,
      Request: P,
      AbortController: J,
      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: it
    }))
      return {
        fetch: b,
        Request: H
      };
    var H = P;
    (H && !H.prototype.hasOwnProperty("signal") || it) && (H = function(ht, $) {
      var st;
      $ && $.signal && (st = $.signal, delete $.signal);
      var tt = new P(ht, $);
      return st && Object.defineProperty(tt, "signal", {
        writable: !1,
        enumerable: !1,
        configurable: !0,
        value: st
      }), tt;
    }, H.prototype = P.prototype);
    var C = b, at = function(ht, $) {
      var st = H && H.prototype.isPrototypeOf(ht) ? ht.signal : $ ? $.signal : void 0;
      if (st) {
        var tt;
        try {
          tt = new DOMException("Aborted", "AbortError");
        } catch (Ke) {
          tt = new Error("Aborted"), tt.name = "AbortError";
        }
        if (st.aborted)
          return Promise.reject(tt);
        var Ve = new Promise(function(Ke, Je) {
          st.addEventListener("abort", function() {
            return Je(tt);
          }, {
            once: !0
          });
        });
        return $ && $.signal && delete $.signal, Promise.race([Ve, C(ht, $)]);
      }
      return C(ht, $);
    };
    return {
      fetch: at,
      Request: H
    };
  }
  (function(l) {
    if (k(l)) {
      if (!l.fetch) {
        console.warn("fetch() is not available, cannot install abortcontroller-polyfill");
        return;
      }
      var f = x(l), b = f.fetch, w = f.Request;
      l.fetch = b, l.Request = w, Object.defineProperty(l, "AbortController", {
        writable: !0,
        enumerable: !1,
        configurable: !0,
        value: v
      }), Object.defineProperty(l, "AbortSignal", {
        writable: !0,
        enumerable: !1,
        configurable: !0,
        value: h
      });
    }
  })(typeof self != "undefined" ? self : Mo);
});
class Lo extends Error {
  constructor(t, e) {
    super(e), y(this, "_body"), Object.setPrototypeOf(this, new.target.prototype), this._body = t;
  }
  get body() {
    return this._body;
  }
}
class Ro extends Error {
  constructor(t, e) {
    super(e), y(this, "_errors"), Object.setPrototypeOf(this, new.target.prototype), this._errors = t.errors;
  }
  get errors() {
    return this._errors;
  }
}
class qo extends Error {
  constructor(t, e) {
    super(e), y(this, "_body"), Object.setPrototypeOf(this, new.target.prototype), this._body = t;
  }
  get body() {
    return this._body;
  }
}
const Io = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Requested-With": "XMLHttpRequest"
}, Ho = 15e3;
function Ao(n, t, e) {
  return ot(this, null, function* () {
    let r;
    const o = setTimeout(() => {
      r = !0, e.abort();
    }, t.timeout);
    try {
      const i = yield n;
      return clearTimeout(o), i;
    } catch (i) {
      if ((i == null ? void 0 : i.name) === "AbortError" && r) {
        const a = { status: 408, statusText: "TIMEOUT" }, u = JSON.stringify({ code: 408, message: "TIMEOUT" });
        return r = void 0, console.error(`${t.method} ${t.url} 408 (Request Timeout)`), new Response(u, a);
      }
      if ((i == null ? void 0 : i.name) === "AbortError" && !r) {
        const a = { status: 500, statusText: "ABORTED" }, u = JSON.stringify({ code: 500, message: "ABORTED" });
        return console.error(`${t.method} ${t.url} AbortError: The operation was aborted.`), new Response(u, a);
      }
      throw console.error(i), i;
    }
  });
}
function Co(n, t = "json") {
  return ot(this, null, function* () {
    if (n.status === 200) {
      let r;
      switch (t) {
        case "arrayBuffer":
          r = yield n.arrayBuffer();
          break;
        case "blob":
          r = yield n.blob();
          break;
        case "text":
          r = yield n.text();
          break;
        case "json":
          r = yield n.json();
      }
      return r;
    }
    const e = {
      url: n.url,
      headers: n.headers,
      status: n.status,
      statusText: n.statusText,
      type: t
    };
    if (n.status === 400 || n.status === 405 || n.status === 412) {
      const r = yield n.json(), o = new Lo(r);
      throw vt(
        "Request failed",
        JSON.stringify(ct(A({}, e), {
          body: o.body
        }))
      ), o.body;
    }
    if (n.status === 403) {
      const r = yield n.json(), o = new qo(r);
      throw vt(
        "Request failed - Forbidden",
        JSON.stringify(ct(A({}, e), {
          body: o.body
        }))
      ), A({
        status: 403
      }, o.body);
    }
    if (n.status === 422) {
      const r = yield n.json(), o = new Ro(r);
      throw vt(
        "Request failed",
        JSON.stringify(ct(A({}, e), {
          body: { code: o.errors }
        }))
      ), { code: JSON.stringify(o.errors) };
    }
    if (n.status === 401) {
      const r = yield n.json();
      throw vt(
        "Request failed",
        JSON.stringify(ct(A({}, e), {
          body: A({}, r)
        }))
      ), A({
        status: 401
      }, r);
    }
    throw vt(
      "Request failed",
      JSON.stringify(ct(A({}, e), {
        body: { code: n.statusText }
      }))
    ), { code: n.statusText };
  });
}
function Yo(n, t, e) {
  const r = { method: n, headers: A(A({}, Io), t) }, o = ["GET", "DELETE"].indexOf(n) === -1 ? { body: JSON.stringify(e) } : {};
  return A(A({}, r), o);
}
function $o(n = "json") {
  switch (n) {
    case "arrayBuffer":
      return "application/octet-stream";
    case "blob":
      return "application/octet-stream";
    case "text":
      return "text/plain";
    default:
      return "application/json";
  }
}
function Pt(n, t) {
  return ot(this, arguments, function* (e, r, o = {}, i, a) {
    const u = new AbortController(), { signal: c } = u, s = o, { timeout: d, type: p } = s, m = qn(s, ["timeout", "type"]), h = Yo(r, A({ Accept: $o(p) }, m), i);
    a == null || a(u);
    const v = yield Ao(
      fetch(e, ct(A({}, h), { signal: c })),
      { url: e, method: r, timeout: d || Ho },
      u
    );
    return Co(v, p);
  });
}
function Fo(n, t, e) {
  return ot(this, null, function* () {
    return Pt(n, "GET", t, void 0, e);
  });
}
function _o(n, t, e, r) {
  return ot(this, null, function* () {
    return Pt(n, "POST", e, t, r);
  });
}
function zo(n, t, e, r) {
  return ot(this, null, function* () {
    return Pt(n, "PUT", e, t, r);
  });
}
function Bo(n, t, e) {
  return ot(this, null, function* () {
    return Pt(n, "DELETE", t, void 0, e);
  });
}
function Qo(n, t, e, r) {
  return ot(this, null, function* () {
    return Pt(n, "PATCH", e, t, r);
  });
}
const Go = { get: Fo, post: _o, put: zo, delete: Bo, patch: Qo };
function W(n) {
  for (var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    e[r - 1] = arguments[r];
  throw Error("[Immer] minified error nr: " + n + (e.length ? " " + e.map(function(o) {
    return "'" + o + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function lt(n) {
  return !!n && !!n[D];
}
function dt(n) {
  var t;
  return !!n && (function(e) {
    if (!e || typeof e != "object")
      return !1;
    var r = Object.getPrototypeOf(e);
    if (r === null)
      return !0;
    var o = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return o === Object || typeof o == "function" && Function.toString.call(o) === ei;
  }(n) || Array.isArray(n) || !!n[xe] || !!(!((t = n.constructor) === null || t === void 0) && t[xe]) || Jt(n) || te(n));
}
function ft(n, t, e) {
  e === void 0 && (e = !1), wt(n) === 0 ? (e ? Object.keys : mt)(n).forEach(function(r) {
    e && typeof r == "symbol" || t(r, n[r], n);
  }) : n.forEach(function(r, o) {
    return t(o, r, n);
  });
}
function wt(n) {
  var t = n[D];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(n) ? 1 : Jt(n) ? 2 : te(n) ? 3 : 0;
}
function pt(n, t) {
  return wt(n) === 2 ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t);
}
function Wo(n, t) {
  return wt(n) === 2 ? n.get(t) : n[t];
}
function Ge(n, t, e) {
  var r = wt(n);
  r === 2 ? n.set(t, e) : r === 3 ? n.add(e) : n[t] = e;
}
function We(n, t) {
  return n === t ? n !== 0 || 1 / n == 1 / t : n != n && t != t;
}
function Jt(n) {
  return Jo && n instanceof Map;
}
function te(n) {
  return ti && n instanceof Set;
}
function ut(n) {
  return n.o || n.t;
}
function ee(n) {
  if (Array.isArray(n))
    return Array.prototype.slice.call(n);
  var t = Ze(n);
  delete t[D];
  for (var e = mt(t), r = 0; r < e.length; r++) {
    var o = e[r], i = t[o];
    i.writable === !1 && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (t[o] = { configurable: !0, writable: !0, enumerable: i.enumerable, value: n[o] });
  }
  return Object.create(Object.getPrototypeOf(n), t);
}
function re(n, t) {
  return t === void 0 && (t = !1), ne(n) || lt(n) || !dt(n) || (wt(n) > 1 && (n.set = n.add = n.clear = n.delete = Xo), Object.freeze(n), t && ft(n, function(e, r) {
    return re(r, !0);
  }, !0)), n;
}
function Xo() {
  W(2);
}
function ne(n) {
  return n == null || typeof n != "object" || Object.isFrozen(n);
}
function K(n) {
  var t = Xt[n];
  return t || W(18, n), t;
}
function Zo(n, t) {
  Xt[n] || (Xt[n] = t);
}
function Qt() {
  return Ot;
}
function Ht(n, t) {
  t && (K("Patches"), n.u = [], n.s = [], n.v = t);
}
function jt(n) {
  Gt(n), n.p.forEach(Uo), n.p = null;
}
function Gt(n) {
  n === Ot && (Ot = n.l);
}
function me(n) {
  return Ot = { p: [], l: Ot, h: n, m: !0, _: 0 };
}
function Uo(n) {
  var t = n[D];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function At(n, t) {
  t._ = t.p.length;
  var e = t.p[0], r = n !== void 0 && n !== e;
  return t.h.O || K("ES5").S(t, n, r), r ? (e[D].P && (jt(t), W(4)), dt(n) && (n = Et(t, n), t.l || Nt(t, n)), t.u && K("Patches").M(e[D].t, n, t.u, t.s)) : n = Et(t, e, []), jt(t), t.u && t.v(t.u, t.s), n !== Xe ? n : void 0;
}
function Et(n, t, e) {
  if (ne(t))
    return t;
  var r = t[D];
  if (!r)
    return ft(t, function(u, c) {
      return ye(n, r, t, u, c, e);
    }, !0), t;
  if (r.A !== n)
    return t;
  if (!r.P)
    return Nt(n, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var o = r.i === 4 || r.i === 5 ? r.o = ee(r.k) : r.o, i = o, a = !1;
    r.i === 3 && (i = new Set(o), o.clear(), a = !0), ft(i, function(u, c) {
      return ye(n, r, o, u, c, e, a);
    }), Nt(n, o, !1), e && n.u && K("Patches").N(r, e, n.u, n.s);
  }
  return r.o;
}
function ye(n, t, e, r, o, i, a) {
  if (lt(o)) {
    var u = Et(n, o, i && t && t.i !== 3 && !pt(t.R, r) ? i.concat(r) : void 0);
    if (Ge(e, r, u), !lt(u))
      return;
    n.m = !1;
  } else
    a && e.add(o);
  if (dt(o) && !ne(o)) {
    if (!n.h.D && n._ < 1)
      return;
    Et(n, o), t && t.A.l || Nt(n, o);
  }
}
function Nt(n, t, e) {
  e === void 0 && (e = !1), !n.l && n.h.D && n.m && re(t, e);
}
function Ct(n, t) {
  var e = n[D];
  return (e ? ut(e) : n)[t];
}
function ge(n, t) {
  if (t in n)
    for (var e = Object.getPrototypeOf(n); e; ) {
      var r = Object.getOwnPropertyDescriptor(e, t);
      if (r)
        return r;
      e = Object.getPrototypeOf(e);
    }
}
function et(n) {
  n.P || (n.P = !0, n.l && et(n.l));
}
function Yt(n) {
  n.o || (n.o = ee(n.t));
}
function Wt(n, t, e) {
  var r = Jt(t) ? K("MapSet").F(t, e) : te(t) ? K("MapSet").T(t, e) : n.O ? function(o, i) {
    var a = Array.isArray(o), u = { i: a ? 1 : 0, A: i ? i.A : Qt(), P: !1, I: !1, R: {}, l: i, t: o, k: null, o: null, j: null, C: !1 }, c = u, s = Tt;
    a && (c = [u], s = xt);
    var d = Proxy.revocable(c, s), p = d.revoke, m = d.proxy;
    return u.k = m, u.j = p, m;
  }(t, e) : K("ES5").J(t, e);
  return (e ? e.A : Qt()).p.push(r), r;
}
function Vo(n) {
  return lt(n) || W(22, n), function t(e) {
    if (!dt(e))
      return e;
    var r, o = e[D], i = wt(e);
    if (o) {
      if (!o.P && (o.i < 4 || !K("ES5").K(o)))
        return o.t;
      o.I = !0, r = be(e, i), o.I = !1;
    } else
      r = be(e, i);
    return ft(r, function(a, u) {
      o && Wo(o.t, a) === u || Ge(r, a, t(u));
    }), i === 3 ? new Set(r) : r;
  }(n);
}
function be(n, t) {
  switch (t) {
    case 2:
      return new Map(n);
    case 3:
      return Array.from(n);
  }
  return ee(n);
}
function Ko() {
  function n(i, a) {
    var u = o[i];
    return u ? u.enumerable = a : o[i] = u = { configurable: !0, enumerable: a, get: function() {
      var c = this[D];
      return Tt.get(c, i);
    }, set: function(c) {
      var s = this[D];
      Tt.set(s, i, c);
    } }, u;
  }
  function t(i) {
    for (var a = i.length - 1; a >= 0; a--) {
      var u = i[a][D];
      if (!u.P)
        switch (u.i) {
          case 5:
            r(u) && et(u);
            break;
          case 4:
            e(u) && et(u);
        }
    }
  }
  function e(i) {
    for (var a = i.t, u = i.k, c = mt(u), s = c.length - 1; s >= 0; s--) {
      var d = c[s];
      if (d !== D) {
        var p = a[d];
        if (p === void 0 && !pt(a, d))
          return !0;
        var m = u[d], h = m && m[D];
        if (h ? h.t !== p : !We(m, p))
          return !0;
      }
    }
    var v = !!a[D];
    return c.length !== mt(a).length + (v ? 0 : 1);
  }
  function r(i) {
    var a = i.k;
    if (a.length !== i.t.length)
      return !0;
    var u = Object.getOwnPropertyDescriptor(a, a.length - 1);
    if (u && !u.get)
      return !0;
    for (var c = 0; c < a.length; c++)
      if (!a.hasOwnProperty(c))
        return !0;
    return !1;
  }
  var o = {};
  Zo("ES5", { J: function(i, a) {
    var u = Array.isArray(i), c = function(d, p) {
      if (d) {
        for (var m = Array(p.length), h = 0; h < p.length; h++)
          Object.defineProperty(m, "" + h, n(h, !0));
        return m;
      }
      var v = Ze(p);
      delete v[D];
      for (var k = mt(v), x = 0; x < k.length; x++) {
        var l = k[x];
        v[l] = n(l, d || !!v[l].enumerable);
      }
      return Object.create(Object.getPrototypeOf(p), v);
    }(u, i), s = { i: u ? 5 : 4, A: a ? a.A : Qt(), P: !1, I: !1, R: {}, l: a, t: i, k: c, o: null, g: !1, C: !1 };
    return Object.defineProperty(c, D, { value: s, writable: !0 }), c;
  }, S: function(i, a, u) {
    u ? lt(a) && a[D].A === i && t(i.p) : (i.u && function c(s) {
      if (s && typeof s == "object") {
        var d = s[D];
        if (d) {
          var p = d.t, m = d.k, h = d.R, v = d.i;
          if (v === 4)
            ft(m, function(b) {
              b !== D && (p[b] !== void 0 || pt(p, b) ? h[b] || c(m[b]) : (h[b] = !0, et(d)));
            }), ft(p, function(b) {
              m[b] !== void 0 || pt(m, b) || (h[b] = !1, et(d));
            });
          else if (v === 5) {
            if (r(d) && (et(d), h.length = !0), m.length < p.length)
              for (var k = m.length; k < p.length; k++)
                h[k] = !1;
            else
              for (var x = p.length; x < m.length; x++)
                h[x] = !0;
            for (var l = Math.min(m.length, p.length), f = 0; f < l; f++)
              m.hasOwnProperty(f) || (h[f] = !0), h[f] === void 0 && c(m[f]);
          }
        }
      }
    }(i.p[0]), t(i.p));
  }, K: function(i) {
    return i.i === 4 ? e(i) : r(i);
  } });
}
var we, Ot, oe = typeof Symbol != "undefined" && typeof Symbol("x") == "symbol", Jo = typeof Map != "undefined", ti = typeof Set != "undefined", ve = typeof Proxy != "undefined" && Proxy.revocable !== void 0 && typeof Reflect != "undefined", Xe = oe ? Symbol.for("immer-nothing") : ((we = {})["immer-nothing"] = !0, we), xe = oe ? Symbol.for("immer-draftable") : "__$immer_draftable", D = oe ? Symbol.for("immer-state") : "__$immer_state", ei = "" + Object.prototype.constructor, mt = typeof Reflect != "undefined" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(n) {
  return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, Ze = Object.getOwnPropertyDescriptors || function(n) {
  var t = {};
  return mt(n).forEach(function(e) {
    t[e] = Object.getOwnPropertyDescriptor(n, e);
  }), t;
}, Xt = {}, Tt = { get: function(n, t) {
  if (t === D)
    return n;
  var e = ut(n);
  if (!pt(e, t))
    return function(o, i, a) {
      var u, c = ge(i, a);
      return c ? "value" in c ? c.value : (u = c.get) === null || u === void 0 ? void 0 : u.call(o.k) : void 0;
    }(n, e, t);
  var r = e[t];
  return n.I || !dt(r) ? r : r === Ct(n.t, t) ? (Yt(n), n.o[t] = Wt(n.A.h, r, n)) : r;
}, has: function(n, t) {
  return t in ut(n);
}, ownKeys: function(n) {
  return Reflect.ownKeys(ut(n));
}, set: function(n, t, e) {
  var r = ge(ut(n), t);
  if (r != null && r.set)
    return r.set.call(n.k, e), !0;
  if (!n.P) {
    var o = Ct(ut(n), t), i = o == null ? void 0 : o[D];
    if (i && i.t === e)
      return n.o[t] = e, n.R[t] = !1, !0;
    if (We(e, o) && (e !== void 0 || pt(n.t, t)))
      return !0;
    Yt(n), et(n);
  }
  return n.o[t] === e && (e !== void 0 || t in n.o) || Number.isNaN(e) && Number.isNaN(n.o[t]) || (n.o[t] = e, n.R[t] = !0), !0;
}, deleteProperty: function(n, t) {
  return Ct(n.t, t) !== void 0 || t in n.t ? (n.R[t] = !1, Yt(n), et(n)) : delete n.R[t], n.o && delete n.o[t], !0;
}, getOwnPropertyDescriptor: function(n, t) {
  var e = ut(n), r = Reflect.getOwnPropertyDescriptor(e, t);
  return r && { writable: !0, configurable: n.i !== 1 || t !== "length", enumerable: r.enumerable, value: e[t] };
}, defineProperty: function() {
  W(11);
}, getPrototypeOf: function(n) {
  return Object.getPrototypeOf(n.t);
}, setPrototypeOf: function() {
  W(12);
} }, xt = {};
ft(Tt, function(n, t) {
  xt[n] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), xt.deleteProperty = function(n, t) {
  return xt.set.call(this, n, t, void 0);
}, xt.set = function(n, t, e) {
  return Tt.set.call(this, n[0], t, e, n[0]);
};
var ri = function() {
  function n(e) {
    var r = this;
    this.O = ve, this.D = !0, this.produce = function(o, i, a) {
      if (typeof o == "function" && typeof i != "function") {
        var u = i;
        i = o;
        var c = r;
        return function(k) {
          var x = this;
          k === void 0 && (k = u);
          for (var l = arguments.length, f = Array(l > 1 ? l - 1 : 0), b = 1; b < l; b++)
            f[b - 1] = arguments[b];
          return c.produce(k, function(w) {
            var P;
            return (P = i).call.apply(P, [x, w].concat(f));
          });
        };
      }
      var s;
      if (typeof i != "function" && W(6), a !== void 0 && typeof a != "function" && W(7), dt(o)) {
        var d = me(r), p = Wt(r, o, void 0), m = !0;
        try {
          s = i(p), m = !1;
        } finally {
          m ? jt(d) : Gt(d);
        }
        return typeof Promise != "undefined" && s instanceof Promise ? s.then(function(k) {
          return Ht(d, a), At(k, d);
        }, function(k) {
          throw jt(d), k;
        }) : (Ht(d, a), At(s, d));
      }
      if (!o || typeof o != "object") {
        if ((s = i(o)) === void 0 && (s = o), s === Xe && (s = void 0), r.D && re(s, !0), a) {
          var h = [], v = [];
          K("Patches").M(o, s, h, v), a(h, v);
        }
        return s;
      }
      W(21, o);
    }, this.produceWithPatches = function(o, i) {
      if (typeof o == "function")
        return function(s) {
          for (var d = arguments.length, p = Array(d > 1 ? d - 1 : 0), m = 1; m < d; m++)
            p[m - 1] = arguments[m];
          return r.produceWithPatches(s, function(h) {
            return o.apply(void 0, [h].concat(p));
          });
        };
      var a, u, c = r.produce(o, i, function(s, d) {
        a = s, u = d;
      });
      return typeof Promise != "undefined" && c instanceof Promise ? c.then(function(s) {
        return [s, a, u];
      }) : [c, a, u];
    }, typeof (e == null ? void 0 : e.useProxies) == "boolean" && this.setUseProxies(e.useProxies), typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze);
  }
  var t = n.prototype;
  return t.createDraft = function(e) {
    dt(e) || W(8), lt(e) && (e = Vo(e));
    var r = me(this), o = Wt(this, e, void 0);
    return o[D].C = !0, Gt(r), o;
  }, t.finishDraft = function(e, r) {
    var o = e && e[D], i = o.A;
    return Ht(i, r), At(void 0, i);
  }, t.setAutoFreeze = function(e) {
    this.D = e;
  }, t.setUseProxies = function(e) {
    e && !ve && W(20), this.O = e;
  }, t.applyPatches = function(e, r) {
    var o;
    for (o = r.length - 1; o >= 0; o--) {
      var i = r[o];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    o > -1 && (r = r.slice(o + 1));
    var a = K("Patches").$;
    return lt(e) ? a(e, r) : this.produce(e, function(u) {
      return a(u, r);
    });
  }, n;
}(), Q = new ri();
Q.produce;
Q.produceWithPatches.bind(Q);
Q.setAutoFreeze.bind(Q);
Q.setUseProxies.bind(Q);
Q.applyPatches.bind(Q);
Q.createDraft.bind(Q);
Q.finishDraft.bind(Q);
var Ue = globalThis && globalThis.__extends || function() {
  var n = function(t, e) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, n(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    n(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), ni = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(d) {
      return c([s, d]);
    };
  }
  function c(s) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; e; )
      try {
        if (r = 1, o && (i = s[0] & 2 ? o.return : s[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, s[1])).done)
          return i;
        switch (o = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (i = e.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < i[1]) {
              e.label = i[1], i = s;
              break;
            }
            if (i && e.label < i[2]) {
              e.label = i[2], e.ops.push(s);
              break;
            }
            i[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (d) {
        s = [6, d], o = 0;
      } finally {
        r = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, St = globalThis && globalThis.__spreadArray || function(n, t) {
  for (var e = 0, r = t.length, o = n.length; e < r; e++, o++)
    n[o] = t[e];
  return n;
}, oi = Object.defineProperty, ii = Object.defineProperties, ai = Object.getOwnPropertyDescriptors, ke = Object.getOwnPropertySymbols, si = Object.prototype.hasOwnProperty, ui = Object.prototype.propertyIsEnumerable, Oe = function(n, t, e) {
  return t in n ? oi(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
}, kt = function(n, t) {
  for (var e in t || (t = {}))
    si.call(t, e) && Oe(n, e, t[e]);
  if (ke)
    for (var r = 0, o = ke(t); r < o.length; r++) {
      var e = o[r];
      ui.call(t, e) && Oe(n, e, t[e]);
    }
  return n;
}, $t = function(n, t) {
  return ii(n, ai(t));
}, ci = function(n, t, e) {
  return new Promise(function(r, o) {
    var i = function(c) {
      try {
        u(e.next(c));
      } catch (s) {
        o(s);
      }
    }, a = function(c) {
      try {
        u(e.throw(c));
      } catch (s) {
        o(s);
      }
    }, u = function(c) {
      return c.done ? r(c.value) : Promise.resolve(c.value).then(i, a);
    };
    u((e = e.apply(n, t)).next());
  });
};
function yt(n, t) {
  function e() {
    for (var r = [], o = 0; o < arguments.length; o++)
      r[o] = arguments[o];
    if (t) {
      var i = t.apply(void 0, r);
      if (!i)
        throw new Error("prepareAction did not return an object");
      return kt(kt({
        type: n,
        payload: i.payload
      }, "meta" in i && { meta: i.meta }), "error" in i && { error: i.error });
    }
    return { type: n, payload: r[0] };
  }
  return e.toString = function() {
    return "" + n;
  }, e.type = n, e.match = function(r) {
    return r.type === n;
  }, e;
}
(function(n) {
  Ue(t, n);
  function t() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    var o = n.apply(this, e) || this;
    return Object.setPrototypeOf(o, t.prototype), o;
  }
  return Object.defineProperty(t, Symbol.species, {
    get: function() {
      return t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.concat = function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return n.prototype.concat.apply(this, e);
  }, t.prototype.prepend = function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return e.length === 1 && Array.isArray(e[0]) ? new (t.bind.apply(t, St([void 0], e[0].concat(this))))() : new (t.bind.apply(t, St([void 0], e.concat(this))))();
  }, t;
})(Array);
(function(n) {
  Ue(t, n);
  function t() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    var o = n.apply(this, e) || this;
    return Object.setPrototypeOf(o, t.prototype), o;
  }
  return Object.defineProperty(t, Symbol.species, {
    get: function() {
      return t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.concat = function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return n.prototype.concat.apply(this, e);
  }, t.prototype.prepend = function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return e.length === 1 && Array.isArray(e[0]) ? new (t.bind.apply(t, St([void 0], e[0].concat(this))))() : new (t.bind.apply(t, St([void 0], e.concat(this))))();
  }, t;
})(Array);
var li = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", di = function(n) {
  n === void 0 && (n = 21);
  for (var t = "", e = n; e--; )
    t += li[Math.random() * 64 | 0];
  return t;
}, fi = [
  "name",
  "message",
  "stack",
  "code"
], Ft = (
  /** @class */
  function() {
    function n(t, e) {
      this.payload = t, this.meta = e;
    }
    return n;
  }()
), Te = (
  /** @class */
  function() {
    function n(t, e) {
      this.payload = t, this.meta = e;
    }
    return n;
  }()
), hi = function(n) {
  if (typeof n == "object" && n !== null) {
    for (var t = {}, e = 0, r = fi; e < r.length; e++) {
      var o = r[e];
      typeof n[o] == "string" && (t[o] = n[o]);
    }
    return t;
  }
  return { message: String(n) };
};
(function() {
  function n(t, e, r) {
    var o = yt(t + "/fulfilled", function(s, d, p, m) {
      return {
        payload: s,
        meta: $t(kt({}, m || {}), {
          arg: p,
          requestId: d,
          requestStatus: "fulfilled"
        })
      };
    }), i = yt(t + "/pending", function(s, d, p) {
      return {
        payload: void 0,
        meta: $t(kt({}, p || {}), {
          arg: d,
          requestId: s,
          requestStatus: "pending"
        })
      };
    }), a = yt(t + "/rejected", function(s, d, p, m, h) {
      return {
        payload: m,
        error: (r && r.serializeError || hi)(s || "Rejected"),
        meta: $t(kt({}, h || {}), {
          arg: p,
          requestId: d,
          rejectedWithValue: !!m,
          requestStatus: "rejected",
          aborted: (s == null ? void 0 : s.name) === "AbortError",
          condition: (s == null ? void 0 : s.name) === "ConditionError"
        })
      };
    }), u = typeof AbortController != "undefined" ? AbortController : (
      /** @class */
      function() {
        function s() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return s.prototype.abort = function() {
        }, s;
      }()
    );
    function c(s) {
      return function(d, p, m) {
        var h = r != null && r.idGenerator ? r.idGenerator(s) : di(), v = new u(), k;
        function x(f) {
          k = f, v.abort();
        }
        var l = function() {
          return ci(this, null, function() {
            var f, b, w, P, J, Y, it;
            return ni(this, function(H) {
              switch (H.label) {
                case 0:
                  return H.trys.push([0, 4, , 5]), P = (f = r == null ? void 0 : r.condition) == null ? void 0 : f.call(r, s, { getState: p, extra: m }), mi(P) ? [4, P] : [3, 2];
                case 1:
                  P = H.sent(), H.label = 2;
                case 2:
                  if (P === !1 || v.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return J = new Promise(function(C, at) {
                    return v.signal.addEventListener("abort", function() {
                      return at({
                        name: "AbortError",
                        message: k || "Aborted"
                      });
                    });
                  }), d(i(h, s, (b = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : b.call(r, { requestId: h, arg: s }, { getState: p, extra: m }))), [4, Promise.race([
                    J,
                    Promise.resolve(e(s, {
                      dispatch: d,
                      getState: p,
                      extra: m,
                      requestId: h,
                      signal: v.signal,
                      abort: x,
                      rejectWithValue: function(C, at) {
                        return new Ft(C, at);
                      },
                      fulfillWithValue: function(C, at) {
                        return new Te(C, at);
                      }
                    })).then(function(C) {
                      if (C instanceof Ft)
                        throw C;
                      return C instanceof Te ? o(C.payload, h, s, C.meta) : o(C, h, s);
                    })
                  ])];
                case 3:
                  return w = H.sent(), [3, 5];
                case 4:
                  return Y = H.sent(), w = Y instanceof Ft ? a(null, h, s, Y.payload, Y.meta) : a(Y, h, s), [3, 5];
                case 5:
                  return it = r && !r.dispatchConditionRejection && a.match(w) && w.meta.condition, it || d(w), [2, w];
              }
            });
          });
        }();
        return Object.assign(l, {
          abort: x,
          requestId: h,
          arg: s,
          unwrap: function() {
            return l.then(pi);
          }
        });
      };
    }
    return Object.assign(c, {
      pending: i,
      rejected: a,
      fulfilled: o,
      typePrefix: t
    });
  }
  return n.withTypes = function() {
    return n;
  }, n;
})();
function pi(n) {
  if (n.meta && n.meta.rejectedWithValue)
    throw n.payload;
  if (n.error)
    throw n.error;
  return n.payload;
}
function mi(n) {
  return n !== null && typeof n == "object" && typeof n.then == "function";
}
var ie = "listenerMiddleware";
yt(ie + "/add");
yt(ie + "/removeAll");
yt(ie + "/remove");
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window != "undefined" ? window : typeof global != "undefined" ? global : globalThis);
Ko();
function yi(n, t) {
  return It(this, null, function* () {
    return yield Go.post(t, n);
  });
}
const gi = () => {
  const { portlet: n, config: t } = ir(je), { unionText: e } = sr(), r = ue(), [o, i] = ar(), a = ue(""), {
    fetcher: u,
    data: c,
    error: s,
    loading: d
  } = ur(t.changeLoginUrl, {
    method: "POST",
    manual: !0
  });
  ce(() => {
    c && (window.location.href = c.redirectUrl);
  }, [c]), ce(() => {
    s && (Bt() && G.error(n, `Failed to change user login to ${a.current}`, s), i(e.alert.changeLoginError));
  }, [s, n, e.alert.changeLoginError]);
  const p = (h) => It(void 0, null, function* () {
    let v;
    try {
      v = yield yi({ email: h }, t.validateEmailUrl);
    } catch (k) {
      return Bt() && G.error(n, `Failed to validate email ${h}`, k), i(e.alert.validationError), e.alert.validationError;
    }
    if (!(v != null && v.available))
      return e.validation.email;
  }), m = (h, { setSubmitting: v }) => {
    i(null), a.current = h.email, u(qt(qt({}, h), hr("accountChangeLoginForm"))), v(!1);
  };
  return /* @__PURE__ */ j.jsxs(j.Fragment, { children: [
    /* @__PURE__ */ j.jsx("h1", { children: e.title }),
    o && /* @__PURE__ */ j.jsx(mr, { color: "danger", "data-o2-portlet": n, "data-o2-role": "alert-user", children: o }),
    /* @__PURE__ */ j.jsx("div", { className: "row", children: /* @__PURE__ */ j.jsx("div", { className: "col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3", children: /* @__PURE__ */ j.jsxs(yr, { children: [
      /* @__PURE__ */ j.jsx(le, { active: !0, children: e.steps.first }),
      /* @__PURE__ */ j.jsx(le, { children: e.steps.second })
    ] }) }) }),
    /* @__PURE__ */ j.jsx("p", { children: e.subtitle }),
    /* @__PURE__ */ j.jsxs("p", { children: [
      e.currentEmail,
      /* @__PURE__ */ j.jsx("strong", { children: t.email })
    ] }),
    /* @__PURE__ */ j.jsx(
      wr,
      {
        initialValues: { email: t.email },
        validateOnBlur: !1,
        validateOnChange: !1,
        onSubmit: m,
        children: ({ isSubmitting: h, setFieldValue: v, handleSubmit: k, isValidating: x, validateField: l }) => /* @__PURE__ */ j.jsxs(cr, { children: [
          /* @__PURE__ */ j.jsxs(
            vr,
            {
              id: "account-change-login-form",
              name: "accountChangeLoginForm",
              className: "form-horizontal",
              "data-o2-id": "accountChangeLoginForm",
              "data-testid": "accountChangeLoginForm",
              children: [
                /* @__PURE__ */ j.jsx(
                  xr,
                  {
                    as: gr,
                    type: "email",
                    id: "email-input",
                    name: "email",
                    onBlur: () => l("email"),
                    validate: (f) => Sn(f) || p(f),
                    required: !0,
                    disabled: x || h,
                    "data-o2-id": "accountChangeLoginForm.email",
                    "data-testid": "accountChangeLoginForm.email",
                    label: e.form.email
                  }
                ),
                /* @__PURE__ */ j.jsx(lr, { size: 6, children: /* @__PURE__ */ j.jsxs(
                  dr,
                  {
                    type: "submit",
                    id: "submit-btn",
                    name: "accountChangeLoginForm.submit",
                    fullwidth: !0,
                    disabled: d,
                    "aria-describedby": e.form.submit,
                    "data-o2-id": "accountChangeLoginForm.submit",
                    "data-testid": "accountChangeLoginForm.submit",
                    "data-o2-role": "action-submit",
                    children: [
                      e.form.submit,
                      d && /* @__PURE__ */ j.jsx(br, { "data-testid": "loader-test-id", name: "loading" })
                    ]
                  }
                ) }),
                /* @__PURE__ */ j.jsx(fr, { formName: "accountChangeLoginForm", portlet: n, imperativeRef: r })
              ]
            }
          ),
          !1
        ] })
      }
    )
  ] });
}, bi = {
  title: "Zmena prihlasovacieho mena",
  subtitle: "Váš e-mail bude odteraz slúžiť ako prihlasovacie meno do zóny Moje O2. Po vyplnení formulára Vám na e-mail zašleme overovací kód. Jeho následným zadaním na tejto stránke potvrdíte zmenu Vášho súčasného prihlasovacieho mena na Vašu e-mailovú adresu.",
  currentEmail: "Vaša aktuálna e-mailová adresa je ",
  steps: {
    first: "Zmena údajov",
    second: "Overenie"
  },
  form: {
    email: "E-mailová adresa",
    submit: "Potvrdiť"
  },
  validation: {
    email: "Ľutujeme, Vami zadaný e-mail je už použitý."
  },
  alert: {
    validationError: "Ľutujeme, počas kontroly e-mailovej adresy nastala chyba.",
    changeLoginError: "Ľutujeme, nastala chyba počas zmeny prihlasovacieho mena."
  }
}, $i = ({ namespace: n, data: t }) => /* @__PURE__ */ j.jsx(pr, { portlet: n, initialTexts: bi, children: /* @__PURE__ */ j.jsx(je.Provider, { value: { portlet: n, config: t }, children: /* @__PURE__ */ j.jsx(gi, {}) }) });
export {
  $i as ChangeLoginPortlet
};
//# sourceMappingURL=index.js.map
